import React, {useCallback, useState} from "react";
import CasesTab from "../components/reports/casesTab";
import "../components/reports/reports.scss"
import {TailSpin} from "react-loader-spinner";
import SectorsTab from "../components/reports/sectorsTab";
import SummaryTab from "../components/reports/components/summaryTab";
import CompaniesTab from "../components/reports/companiesTab";
import ReportCard from "../components/reports/ReportCard";
import {TextField} from "@mui/material";
import {apiClient} from "../providers/apiClient";


const SettingsScreen = (props) => {
    const [activeTab, setActiveTab] = useState(1);
    const [testEmail, setTestEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSendEmails = () => {
        if(!testEmail) {
            return;
        }

        setIsLoading(true);
        apiClient.post('api/Settings/test/notifications', {emailAddress: testEmail}).finally(() => {
            setIsLoading(false);
        })
    }
    
    


    return (
        <div className="fk-screen">
            <div className="tabContainer">
                <ReportCard label={'Test notifications'} column isLoading={isLoading}>
                    <TextField
                        label={"Email address"}
                        fullWidth
                        className="fk-input"
                        placeholder={"Type email to send test notifications"}
                        value={testEmail}
                        onChange={(event) => setTestEmail(event.target.value)}
                    />
                    <div
                        className={`tabButton --active`}
                        onClick={handleSendEmails}>
                        Send emails
                    </div>
                </ReportCard>
            </div>
        </div>
    )
}

export default SettingsScreen;